import { render, staticRenderFns } from "./CategoriasCarousel.vue?vue&type=template&id=a1c31e24&scoped=true"
import script from "./CategoriasCarousel.vue?vue&type=script&lang=js"
export * from "./CategoriasCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c31e24",
  null
  
)

export default component.exports